/**
 * TitleFinder Mobile Hotfix — Google Places single-tap fix for iOS
 * This runs independently of tf-address-flow.js as a belt-and-suspenders fix.
 */
(function() {
  if (!('ontouchstart' in window || navigator.maxTouchPoints > 0)) return;
  
  var touching = false;
  
  // Prevent input blur when tapping Google Places dropdown
  document.addEventListener('touchstart', function(e) {
    if (e.target.closest('.pac-container')) {
      touching = true;
      e.preventDefault();
    }
  }, { passive: false, capture: true });
  
  // Simulate click on pac-item so Google Places registers the selection
  document.addEventListener('touchend', function(e) {
    if (!touching) return;
    touching = false;
    var item = e.target.closest('.pac-item');
    if (!item) return;
    e.preventDefault();
    e.stopPropagation();
    item.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
    setTimeout(function() {
      item.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
    }, 30);
  }, { passive: false, capture: true });

  // Also ensure autocomplete initializes even if callback failed
  function ensureAutocomplete() {
    var input = document.getElementById('address-input');
    if (!input || input.__mobileFixApplied) return;
    if (!window.google || !window.google.maps || !window.google.maps.places) return;
    
    // If no autocomplete has been attached yet, init one
    if (!input.__tfAutocomplete && typeof window.initTFAddressAutocomplete === 'function') {
      window.initTFAddressAutocomplete();
    }
    
    // If STILL no autocomplete (old JS version), create one directly
    if (!input.__tfAutocomplete && !input.__mobileFixAC) {
      try {
        var ac = new google.maps.places.Autocomplete(input, {
          types: ['address'],
          componentRestrictions: { country: 'AU' },
          bounds: new google.maps.LatLngBounds(
            new google.maps.LatLng(-29.18, 138.00),
            new google.maps.LatLng(-10.00, 154.00)
          ),
          strictBounds: true,
          fields: ['formatted_address', 'address_components']
        });
        ac.addListener('place_changed', function() {
          var place = ac.getPlace();
          if (!place || !place.formatted_address) return;
          // Check QLD
          var comps = place.address_components || [];
          var inQLD = comps.some(function(c) {
            return c.types.indexOf('administrative_area_level_1') !== -1 &&
                   (c.short_name === 'QLD' || c.long_name === 'Queensland');
          });
          if (!inQLD) {
            input.value = '';
            alert('Sorry, we only service Queensland properties.');
            return;
          }
          input.value = place.formatted_address;
          localStorage.setItem('tf_address', place.formatted_address);
          localStorage.setItem('selectedAddress', place.formatted_address);
          localStorage.setItem('selectedAddressIsQLD', 'true');
          // Dismiss keyboard on mobile
          setTimeout(function() { input.blur(); }, 100);
        });
        input.__mobileFixAC = ac;
      } catch(e) {}
    }
    input.__mobileFixApplied = true;
  }
  
  // Poll until Google Maps is ready
  var attempts = 0;
  var poller = setInterval(function() {
    ensureAutocomplete();
    if (document.getElementById('address-input') && 
        (document.getElementById('address-input').__mobileFixApplied || ++attempts > 100)) {
      clearInterval(poller);
    }
  }, 100);
  
  document.addEventListener('DOMContentLoaded', ensureAutocomplete);
  window.addEventListener('load', ensureAutocomplete);

  // Larger touch targets for pac-items
  var style = document.createElement('style');
  style.textContent = '.pac-container{z-index:10001!important}.pac-item{padding:14px 10px!important;min-height:48px!important;font-size:16px!important;line-height:1.4!important;cursor:pointer!important;touch-action:manipulation!important}.pac-item:active{background:#e8f4f8!important}';
  document.head.appendChild(style);
})();
